import React, { useState, useEffect } from "react";
import "./Buy.css";
import { IoAlertOutline } from "react-icons/io5";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { analytics } from "../../firebase/firebase";
import { logEvent } from "firebase/analytics";
import { config } from "../../config/config";
import GoogleButton from "../../auth/GoogleAuth";
import { useRef } from "react";
import LeftPanel from "../../components/LeftPanel";
import NotificationBar from "../../components/NotificationBar";
import { useSearchParams } from 'react-router-dom';
import Loader from "../../components/Loader";
const Buy = ({ showBackButton = true,noMargin }) => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [plans, setPlans] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const premiumButtonRef = useRef(null);
  const googleAuthRef = useRef(null);
const [searchParams] = useSearchParams(); 
  //Notification
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationType, setNotificationType] = useState("error");
const isMobile = window.matchMedia("(max-width: 767px)").matches;

  const triggerNotification = (message) => {
    setNotificationMessage(message);
    setShowNotification(true);
  };

  useEffect(() => {
    const fetchPaypalPlans = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${config.baseURL}/get_dodo_plans.php`);
        if (!response.ok) throw new Error("Failed to fetch PayPal plans");
        const data = await response.json();
        const transformedPlans = data.items.map((items) => {
          return {
            id: items.product_id,
            name: items.name,
            currency: "USD",
            amount: items.price,
            interval:
              items.name === "Weekly"
                ? "1"
                : items.name === "Monthly"
                ? "2"
                : "2",
            intervalCount: items.name || 1,
          };
        });
        setPlans(transformedPlans);
        logEvent(analytics, "fetch_paypal_plans_FacelessVideo", {});
        checkSubscription();
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPaypalPlans();
    checkActivePlan();
  }, []);

   useEffect(() => {
    const reason = searchParams.get("reason");

    if (reason === "limit") {
      triggerNotification("Buy Premium to continue!");
    }
  }, [searchParams]);



  const checkSubscription = async () => {
    try {
      const response = await fetch(`${config.baseURL}/check_subscription.php`, {
        method: "GET",
        credentials: "include",
      });

      const data = await response.json(); // Parse the response as JSON

      if (data.error) {
      } else {
                  const {
            subscription_status: rawStatus,
            plan_id: rawPlanId
          } = data;
              const status = rawStatus?.toLowerCase?.() || '';
      const planId = rawPlanId?.toUpperCase?.() || '';

      if (status === 'active') {
        // only save if active
        sessionStorage.setItem('ActiveSubscription', planId);
      } else {
  
          sessionStorage.removeItem('ActiveSubscription');
        }
              }
    } catch (error) {}
  };

  const handleLoginSuccess = (userProfile) => {
    if (userProfile) {
      
      localStorage.setItem("showComponent", "true");
      localStorage.setItem("loginSuccess", "true");

      logEvent(analytics, "Login Button on buy premium", {
        button_name: "login_button_FacelessVideo",
      });

      checkAndSubscribeOnLoad();
    } else {
    }
  };
  const handleSelectedPlanFromStorage = () => {
    const planId = localStorage.getItem("selectedPlan");

    // If a plan ID exists in localStorage, call handleSelect
    if (planId) {
      handleSelect(planId);
    }
  };

  // UseEffect to run only after successful login (check loginSuccess flag)
  useEffect(() => {
    // Check if login was successful (i.e., loginSuccess flag exists in localStorage)
    const loginSuccess = localStorage.getItem("loginSuccess");

    if (loginSuccess) {
      // If login was successful, handle the selected plan
      handleSelectedPlanFromStorage();

      // Remove the login success flag after processing
      localStorage.removeItem("loginSuccess");
    }
  }, []);

  const handleLoginFailure = (error) => {
    if (error.error) {
      alert(`Login failed: ${error.error}`);
    } else {
    }
  };

  const checkActivePlan = () => {
    const storedPlanId =  sessionStorage.getItem("ActiveSubscription");
  

    if (storedPlanId) {
      setPlans((prevPlans) =>
        prevPlans.map((plan) => {
          const isActive = plan.id === storedPlanId;
          return isActive
            ? { ...plan, active: true }
            : { ...plan, active: false };
        })
      );
    }
  };

  const handleSelect = (planId) => {
    setSelectedPlan(planId);
    localStorage.setItem("selectedPlan", planId);
    logEvent(analytics, "plan_selected_FacelessVideo", {
      plan_id: planId,
    });
  };

  const handleSubscribe = async (selectedPlanId) => {
  // Track that user clicked Subscribe button
  logEvent(analytics, "subscribe_button_clicked_FacelessVideo", {
    selected_plan_id: selectedPlanId
  });

  try {
    localStorage.setItem("selectedPlanIdForReuse", selectedPlanId);

    const response = await fetch(`${config.baseURL}/validate_token.php`, {
      method: "GET",
      credentials: "include",
    });

    // Explicitly check for 401
    if (response.status === 401) {
      googleAuthRef.current.login();
      return;
    }

    const data = await response.json();

    if (
      response.status !== 200 ||
      data.status !== "success" ||
      !data.user ||
      !data.user.email
    ) {
      googleAuthRef.current.login();
      return;
    }

    const userEmail = data.user.email;
    const redirectUrl = `https://checkout.dodopayments.com/buy/${selectedPlanId}?quantity=1&redirect_url=https://generator.video/subscription-handler&email=${encodeURIComponent(userEmail)}`;
    window.open(redirectUrl, "_blank");
  } catch (error) {
    triggerNotification("A network error occurred. Please try again.");

    // Log the error
    logEvent(analytics, "subscribe_button_error_FacelessVideo", {
      selected_plan_id: selectedPlanId,
      error_message: error.message || "Unknown error",
      error_stack: error.stack || "No stack trace"
    });
  }
};


  const checkAndSubscribeOnLoad = () => {
    const selectedPlanId = localStorage.getItem("selectedPlanIdForReuse");

    if (selectedPlanId) {
      // If a selected plan ID exists in localStorage, call handleSubscribe
      handleSubscribe(selectedPlanId);

      // Remove the selected plan ID from localStorage after it has been used
      localStorage.removeItem("selectedPlanIdForReuse");
    }

    // After running the logic, remove the window.onload event to prevent it from running again
    window.onload = null; // This will prevent the function from being called again
  };

  // Call this function when the page is loaded
  checkAndSubscribeOnLoad();


  return (
    <div className={`BuyPremiumPage ${noMargin ? "no-margin" : ""}`}>
     {loading && <Loader show={loading} />}
     {showBackButton !== false &&  <LeftPanel />}
      {showBackButton !== false && isMobile && (
        <Link to="/Dashboard" ><button
          className="back-button-buypage"
          ref={premiumButtonRef}
         
        >
          <img
            className="back-button-buypage"
            src={config.Backbutton}
            alt="Back"
          />
         
        </button></Link>
      )}

      <div
        className={`subscription_BuyPage ${noMargin ? "no-margin" : ""}`}
        id="Pricing_BuyPage"
      >
        <div className="subscription_title_BuyPage">Pricing Plan</div>
        <div className="subscription_subtitle_BuyPage">
          Pick the plan that best fits what you're looking for
        </div>

        
          <div className="plans_wrapper_BuyPage">
           {plans.map((plan, index) => {
 const storedPlanId = sessionStorage.getItem("ActiveSubscription") || '';
const isActive = storedPlanId.toUpperCase() === plan.id.toUpperCase();

  return (
    <div className={`plan-${index + 1}_BuyPage`} key={plan.id}>
      {isActive && (
        <div className="active_label_BuyPage">Active Plan</div>
      )}
      <div>
        <div className="price_details_BuyPage">
          <div className={`price${index + 1}_BuyPage`}>
            ${plan.amount / 100}
          </div>
          <p className={`price_interval${index + 1}_BuyPage`}>
            /
            {plan.name === "Weekly"
              ? "Weekly"
              : plan.name === "Half Yearly"
              ? "Half Yearly"
              : "Yearly"}
          </p>
        </div>

        <div className={`discription${index + 1}_BuyPage`}>
          <div className={`price${index + 1}_BuyPage`}>
            {plan.name}
          </div>
          {index === 0 && (
            <div className={`discription_subtitle1_BuyPage`}>
              Unleash the power of automation
            </div>
          )}
          {index === 1 && (
            <div className={`discription_subtitle2_BuyPage`}>
              Advanced tools to take your work to the next level.
            </div>
          )}
          {index === 2 && (
            <div className={`discription_subtitle3_BuyPage`}>
              Automation plus enterprise-grade features
            </div>
          )}
        </div>

        <div className="points_list_full_BuyPage">
          {[
            {
              text: "Unlimited Text to Video Generator",
              feature: "textToVideo",
            },
            { text: "Unlimited HD Exports", feature: "hdExports" },
            { text: "No Watermarks", feature: "noWatermarks" },
            { text: "Ads Free", feature: "adsFree" },
            { text: "Unlimited BG Music", feature: "bgMusic" },
            {
              text: "Unlimited Stock Footages & Videos",
              feature: "stockFootage",
            },
            { text: "HD Resolution", feature: "hdResolution" },
          ].map((point, pointIndex) => {
            let isFeatureAvailable = true;

            if (plan.name === "Weekly") {
              if (
                point.feature === "bgMusic" ||
                point.feature === "stockFootage" ||
                point.feature === "hdResolution"
              ) {
                isFeatureAvailable = false;
              }
            } else if (plan.name === "Half Yearly") {
              if (point.feature === "hdResolution") {
                isFeatureAvailable = false;
              }
            }

            return (
              <div
                className={`ponits_list${index + 1}_BuyPage`}
                key={pointIndex}
              >
                <img
                  src={
                    isFeatureAvailable
                      ? config.check_point
                      : config.check_point_locked_white
                  }
                  alt=""
                  className={`colored_check${index + 1}_BuyPage`}
                />
                <img
                  src={
                    isFeatureAvailable
                      ? config.check_point_white
                      : config.check_point_locked_white
                  }
                  alt=""
                  className={`white_check${index + 1}_BuyPage`}
                />
                {point.text}
              </div>
            );
          })}
        </div>
      </div>
      <button
        className={`choose_plan${index + 1}_BuyPage`}
        onClick={() => handleSubscribe(plan.id)}
      >
        Choose plan
      </button>
    </div>
  );
})}
          </div>
       
      </div>
       <div style={{ display: "none" }}>
            <GoogleButton
              ref={googleAuthRef}
              id="logout_header"
              onLoginSuccess={handleLoginSuccess}
              onLoginFailure={handleLoginFailure}
            />
          </div>
      <NotificationBar
        visible={showNotification}
        message={notificationMessage}
        onClose={() => setShowNotification(false)}
      />
    </div>
  );
};

export default Buy;
